import React, { useEffect, useState } from 'react'
import { find } from 'lodash'
import {
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
  Grid,
} from '@material-ui/core'
import {
  Visibility as VisibilityIcon,
  GetApp as GetAppIcon,
} from '@material-ui/icons'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import history from '~/helpers/history'
import SearchInput from '~/components/SearchInput'
import { Creators as PanoramaActions } from '~/store/ducks/panoramas'
import Portlet from '~/components/Portlet'
import ListFooter from '~/components/ListFooter'
import { useSmallScreen } from '~/helpers/useMediaQuery'
import OverlayLoading from '~/components/OverlayLoading'
import EmptyList from '~/components/EmptyList'
import Autocomplete from '~/components/Autocomplete'
import styles from './styles'
import ViewCircularDialog from './components/ViewCircularDialog'

const panoramasSelector = ({ panorama }) => panorama
const useStyles = makeStyles(styles)
const allDepartmentsSelector = ({ panorama: { allDepartments } }) => allDepartments

function PanoramaPage() {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [circularId, setCircularId] = useState(null)
  const { data, options, loading } = useSelector(panoramasSelector)
  const [openViewCircularDialog, setOpenViewCircularDialog] = useState(false)
  const { data: allDepartmentsData } = useSelector(allDepartmentsSelector)

  const isSmallScreen = useSmallScreen()
  useEffect(() => {
    dispatch(PanoramaActions.getPanoramasRequest())
    dispatch(PanoramaActions.getPanoramasAllDepartmentsRequest())
  }, [])

  const handleChangeRowsPerPage = (ev) => {
    const {
      target: { value },
    } = ev
    dispatch(PanoramaActions.setPanoramasPage(0, value))
  }

  const handleChangePage = (_, page) => {
    dispatch(PanoramaActions.setPanoramasPage(page, options.limit))
  }

  const handleViewCircular = (id) => {
    setCircularId(id)
    setOpenViewCircularDialog(true)
  }

  const handleDownloadCircular = (url) => {
    window.open(url, '_blank')
  }

  const handleCloseViewCircularDialog = () => {
    setOpenViewCircularDialog(false)
    setCircularId(null)
    history.push('/panorama')
  }

  const handleSearchChange = (value) => {
    dispatch(PanoramaActions.setPanoramasSearch(value))
    dispatch(PanoramaActions.setPanoramasPage(0, options.limit))
  }

  const handlePropertyFilterChange = (property, value) => {
    dispatch(PanoramaActions.setPanoramasPropertyFilter(property, value))
  }

  const getFilterValue = (property) => {
    if (options.filters) {
      const filterValue = find(options.filters, { name: property })
      return filterValue.value
    }
    return null
  }

  return (
    <>
      <div className={classes.root}>
        <Grid
          container
          justifyContent="flex-start"
          className={classes.gridContainerButton}
        >
          <Grid
            item
            style={{ paddingBottom: isSmallScreen ? 8 : '' }}
            xs={12}
            md={6}
          >
            <SearchInput
              onChange={(e) => handleSearchChange(e.target.value)}
              placeholder="Pesquise pelo nome do arquivo"
            />
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            spacing={2}
            className={classes.filtersWrapper}
          >
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Autocomplete
                onChange={(_, option) => {
                  handlePropertyFilterChange('department_id', option ? option.value : null)
                }}
                options={allDepartmentsData?.map((option) => ({
                  label: option.name,
                  value: option.id,
                }))}
                name="department_id"
                value={getFilterValue('department_id')}
                label="Departamento"
                placeholder="Selecione um departamento"
              />
            </Grid>
          </Grid>
        </Grid>
        <Portlet className={classes.grow}>
          <div className={classes.tableWrapper}>
            {!loading && data.length === 0 && (
              <EmptyList message="Não há circulares para serem visualizadas" />
            )}
            {loading && <OverlayLoading />}
            {!loading && (
              <div className={classes.listWrapper}>
                {data.length > 0 && (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Nome</TableCell>
                        <TableCell>Departamentos</TableCell>
                        <TableCell>Data de cadastro</TableCell>
                        <TableCell />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.map((item) => (
                        <TableRow
                          hover
                          key={item.id}
                          className={classes.tableRow}
                        >
                          <TableCell>{item.name || '-'}</TableCell>
                          <TableCell>{item.departments?.map(department => department.name).join(', ') || '-'}</TableCell>
                          <TableCell>
                            {moment(item.created_at || '-').format(
                              'DD/MM/YYYY HH:mm',
                              'HH/MM',
                            )}
                          </TableCell>
                          <TableCell align="right">
                            <div className={classes.tableCellActions}>
                              <IconButton
                                className={classes.visibilityIcon}
                                onClick={() => handleViewCircular(item.id)}
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                className={classes.visibilityIcon}
                                onClick={() =>
                                  handleDownloadCircular(item.url_pdf_file)
                                }
                              >
                                <GetAppIcon />
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </div>
            )}
          </div>

          {data.length > 0 && (
            <ListFooter
              options={options}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              onChangePage={handleChangePage}
            />
          )}
        </Portlet>
      </div>

      <ViewCircularDialog
        id={circularId}
        open={openViewCircularDialog}
        onClose={handleCloseViewCircularDialog}
      />

    </>
  )
}

export default PanoramaPage
